/**
 * POURQUOI QUELQU'UN VIENT D'ETRE MIS DEHORS, le temps d'une redirection.
 *
 * Le portail et le back-office deconnectent qui n'a rien a y faire, puis renvoient a la
 * connexion. Mais `logout()` met `hasSession` a faux, ce qui fait RE-RENDRE l'ecran, et la
 * branche « pas de session » de chaque `Setup` redirige de son cote : deux redirections
 * courent l'une contre l'autre, et c'est la seconde qui gagne. Constate a l'ecran, on
 * atterrissait sur `?redirect-after-login=` au lieu du message.
 *
 * D'ou ce relais : la garde ne redirige plus, elle DIT pourquoi elle sort, et le seul
 * chemin de redirection qui existe deja s'en sert. Un seul geste, donc rien a arbitrer.
 *
 * `sessionStorage` et non `localStorage` : ce motif ne vaut que pour cette navigation-la,
 * et le garder d'un onglet a l'autre le ferait resurgir sur une connexion qui n'a rien a
 * voir. Il se consomme d'ailleurs a la lecture, pour la meme raison.
 */
const CLE = 'motif-de-sortie';

export const marquerSortie = (motif: string) => {
    try {
        window.sessionStorage.setItem(CLE, motif);
    } catch {
        // Un navigateur qui refuse le stockage ne doit pas empecher la sortie : on perd
        // le message, pas la deconnexion.
    }
};

/** Rend le motif et l'efface : il ne vaut que pour la redirection qui suit. */
export const consommerSortie = (): string | null => {
    try {
        const motif = window.sessionStorage.getItem(CLE);
        if (motif) {
            window.sessionStorage.removeItem(CLE);
        }
        return motif;
    } catch {
        return null;
    }
};
